import apiSlice from "./ApiSlice";

export const BlogApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL JOB WITH PAGINATION
    getAllBlogWithPagination: builder.query({
      providesTags: ["blog"],
      query: (body) => {
        return {
          url: "/blog",
          method: "POST",
          body,
        };
      },
    }),
    // Add
    addBlog: builder.mutation({
      invalidatesTags: ["blog"],
      query: (body) => {
        return {
          url: "/blog/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteBlog: builder.mutation({
      invalidatesTags: ["blog"],
      query: (id) => {
        return {
          url: `/blog/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET JOB BY ID
    getBlogById: builder.query({
      providesTags: ["blog"],
      query: (id) => {
        return {
          url: `/blog/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editBlog: builder.mutation({
      invalidatesTags: ["blog"],
      query: ({ body, id }) => {
        return {
          url: `/blog/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetAllBlogWithPaginationQuery,
  useAddBlogMutation,
  useDeleteBlogMutation,
  useEditBlogMutation,
  useGetBlogByIdQuery,
} = BlogApi;
